export const PROJECT_SETTINGS_RUN_LOGS = {
  DISABLED: 'disabled',
  CONSOLE_LOGS: 'consoleLogs',
  FULL_BUGBUG_DEBUGGING: 'fullBugBugDebugging',
} as const;
